import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'avalanche'),
  es: flattenMessages(es, 'avalanche'),
  ru: flattenMessages(ru, 'avalanche'),
  zh: flattenMessages(zh, 'avalanche'),
};
